import { useQuery } from '@tanstack/react-query';
import { currencyService } from '@/api/services/currency';

export const exchangeRatesQueryKey = ['currency', 'exchange-rates'] as const;

/** Live USD-base FX rates. Cached server-side (1h TTL) and fail-soft, so a long
 *  client `staleTime` is fine — we don't need to re-fetch aggressively. */
export function useExchangeRates() {
  return useQuery({
    queryKey: exchangeRatesQueryKey,
    queryFn: currencyService.exchangeRates,
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
